import { createContext, useContext } from "react";
import type { ColorToken } from "../../designTokens";
import { colorTokens } from "../../designTokens/colors/tokens/colorTokens";
import type { ColorValue } from "../../designTokens/colors/values/colorValues";
import { colorValues } from "../../designTokens/colors/values/colorValues";
import type { ThemeName } from "../types/themeName";

export interface Context {
  themeName: ThemeName;
  getColor: (token: ColorToken | ColorValue) => string;
}

export const getColor = (token: ColorToken | ColorValue): string =>
  Object.assign(colorValues, colorTokens)[token];

const ThemeContext = createContext<Context>({ themeName: "light", getColor });

export const ThemeContextProvider = ThemeContext.Provider;

export const useTheme = (): Context => {
  return useContext(ThemeContext);
};
